var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputerPc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9174 20.0437H11.0825V25.2925H16.9174V20.0437Z",
    fill: "#CBD6DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1946 24.1665H9.8053C9.18362 24.1665 8.67969 24.6704 8.67969 25.2921C8.67969 25.9138 9.18362 26.4177 9.8053 26.4177H18.1945C18.8162 26.4177 19.3201 25.9138 19.3201 25.2921C19.3202 24.6704 18.8163 24.1665 18.1946 24.1665Z",
    fill: "#AFBBC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.086 1.58203H2.91396C1.94361 1.58203 1.15698 2.36871 1.15698 3.33901V19.7903C1.15698 20.7607 1.94361 21.5472 2.91396 21.5472H25.086C26.0564 21.5472 26.8429 20.7606 26.8429 19.7903V3.33901C26.8429 2.36871 26.0563 1.58203 25.086 1.58203Z",
    fill: "#CBD6DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29152 19.7903V3.33901C5.29152 2.36866 6.07815 1.58203 7.0485 1.58203H2.91396C1.94361 1.58203 1.15698 2.36871 1.15698 3.33901V19.7903C1.15698 20.7607 1.94361 21.5472 2.91396 21.5472H7.0485C6.0782 21.5473 5.29152 20.7607 5.29152 19.7903Z",
    fill: "#AFBBC7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2687 4.15674H3.73132V18.1192H24.2687V4.15674Z",
    fill: "#2BC5B1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29159 4.15674H3.73132V18.1192H5.29159V4.15674Z",
    fill: "#00AE95"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20.5979C14.4222 20.5979 14.7645 20.2556 14.7645 19.8334C14.7645 19.4111 14.4222 19.0688 14 19.0688C13.5778 19.0688 13.2355 19.4111 13.2355 19.8334C13.2355 20.2556 13.5778 20.5979 14 20.5979Z",
    fill: "#465059"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9174 21.5476H11.0825V22.8515H16.9174V21.5476Z",
    fill: "#AFBBC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerPc);
export default __webpack_public_path__ + "static/media/computer-pc.883438b6efd324ac8174038f20202258.svg";
export { ForwardRef as ReactComponent };